import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import ids from '../QestIds';
import AsSamplePreparationSection from '../Shared/AS/Preparation/PreparationSection';
import { AsLinearShrinkagePreparationSection } from './AS/Sections';
import AsLinearShrinkageMeasurementsSection from './AS/Sections/MeasurementsSection';
import AsLinearShrinkageResultsSection from './AS/Sections/ResultsSection';
let LinearShrinkageWorksheet: WorksheetRootComponent = () => {
  return (
    <>
      <PageSection heading="Sample Preparation">
        <NamePrefixModifier appendNamePrefix="SamplePreparation">
          <AsSamplePreparationSection />
        </NamePrefixModifier>
      </PageSection>
      <PageSection heading="Test Preparation">
        <AsLinearShrinkagePreparationSection />
      </PageSection>
      <PageSection heading="Measurements">
        <AsLinearShrinkageMeasurementsSection />
      </PageSection>
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <PageSection heading="Results">
        <AsLinearShrinkageResultsSection />
      </PageSection>
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

LinearShrinkageWorksheet.qestIds = [ids.linearShrinkage.AS_1289_5_4_1.rev2008];
LinearShrinkageWorksheet = withInjectedProps(LinearShrinkageWorksheet);

export { LinearShrinkageWorksheet };
export default LinearShrinkageWorksheet;
